import React from 'react';
import { Box, Typography } from 'components/mui';
import { SearchIcon } from 'components/icons';

function CaseListEmpty() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        px: 2,
      }}
    >
      <SearchIcon sx={{ fontSize: 40, color: 'text.disabled', mb: 1.5 }} />
      <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
        No cases found
      </Typography>
      <Typography variant="caption" color="text.disabled">
        Try adjusting your search or filter criteria
      </Typography>
    </Box>
  );
}

export default CaseListEmpty;
